import { forwardRef, InputHTMLAttributes, useState } from 'react'

import './style.scss'
import { Icon } from '..'

type InputType = 'text' | 'password' | 'email' | 'tel' | 'date'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string,
  type?: InputType,
  fullWidth?: boolean,
  error?: boolean,
  version?: '2' | '3' | '',
  icon?: string,
  passwordShow?: boolean
}

type Ref = HTMLInputElement;

const Input = forwardRef<Ref, InputProps>(({ className = '', type = 'text', fullWidth = false, error = false, version = '', icon = '', passwordShow = false, ...rest }, ref) => {
  const [passwordSw, setPasswordSw] = useState<boolean>(false)

  const Cinput = (type?: InputType) => <input type={type} ref={ref} className={`input ${version ? 'input--v' + version : ''} ${fullWidth ? 'w-full' : ''} ${error ? 'input--error' : ''} ${className}`} {...rest} />

  const onPasswordToggle = () => {
    setPasswordSw(!passwordSw)
  }

  return (
    <>
      {icon ?
          <div className={`input-icon-wrapper ${className}`}>
            <Icon name="search" className="input-icon" />
            {Cinput(type)}
          </div>
        :
          passwordShow ?
              <div className={`input-password-wrapper ${className}`}>
                {Cinput(passwordSw ? 'text' : 'password')}
                <Icon
                  name="password-show"
                  color="primary"
                  size={18}
                  className={`input-password-icon ${passwordSw ? 'input-password-icon--active' : ''}`}
                  onClick={onPasswordToggle}
                />
              </div>
            :
              Cinput(type)
      }
    </>
  )
})

export { Input }